export const pageVariables = {
    headers: [
        'MÊS/ANO', '% MÊS', '% ANO', '% ÚLT 12 MESES', 'OBSERVAÇÕES'
    ],
    headerInfo: {
        title: "Gerenciar Índices IPCA",
        description: "Cadastre e edite as taxas do IPCA mensalmente que serão aplicadas aos reajustes de cobertura dos planos vinculados à tabela manual.",
        icon: 'ChartBarIcon'
    },
    inputs: [
        {
            name: "mes_ano",
            type: "month",
            label: "Mês/Ano de Competência"
        },
        {
            name: "percentual_mes",
            type: "number",
            label: "% Ref. Mês",
            step: "any"
        },
        {
            name: "percentual_ano",
            type: "number",
            label: "% Ref. Ano",
            step: "any"
        },
        {
            name: "percentual_12_meses",
            type: "number",
            label: "% Últimos 12 Meses",
            step: "any"
        },
        {
            name: "observacao",
            type: "textarea",
            label: "Observações"
        }   
    ],
    page: process.env.VUE_APP_API_URL + "indices-ipca",
    indicesIpcaGetPage: process.env.VUE_APP_API_URL + "indices-ipca"
};
